import * as React from "react";
import { availableAccessRightsStore } from "../Stores/AvailableAccessRightsStore";
import { SelectProps } from "antd/lib/select";
import { Select } from "antd";
import { WithTranslation, withTranslation } from "react-i18next";
import { I18N_NS } from "Config/i18n";
const Option = Select.Option;

interface AccessRightsSelectProps extends SelectProps<string>, WithTranslation {
  disabledOption?: boolean;
}
export const AccessRightsSelect = withTranslation(I18N_NS.PROJECT)(
  class extends React.Component<AccessRightsSelectProps> {
    // If you need explanations, check pave-3469
    get disabledOptionEntry() {
      const { t } = this.props;
      return (
        <Option key={"DISABLED"} value={"DISABLED"}>
          {t("Only Administrators")}
        </Option>
      );
    }
    render() {
      return (
        <Select style={{ minWidth: 150 }} {...this.props} loading={availableAccessRightsStore.state === "LOADING"}>
          {this.props.disabledOption && this.disabledOptionEntry}
          {availableAccessRightsStore.data.map((item) => (
            <Option key={item.value} value={item.value}>
              {item.key}
            </Option>
          ))}
        </Select>
      );
    }
  }
);
